module.exports = __webpack_public_path__ + "media/images/landing_2-images-9cf9ab041846b8db1c483d1f83fc2853.png";